<template>
  <v-dialog :value="isActive" @click:outside="closeDialog" max-width="700" scrollable>
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-card-title class="font-weight-medium primary--text">
            Enviar mensaje rápido
          </v-card-title>
        </v-card-title>

        <v-card-text style="max-height: 600px; overflow-y: auto;">
          <v-form>
            <v-row dense justify="center">
              <v-col cols="12" class="py-0">
                <ValidationProvider name="WhatsApp" rules="required" v-slot="{ errors }">
                  <v-select
                    :disabled="isLoading"
                    v-model="selectedItem"
                    :items="whatsappList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    return-object
                    prepend-inner-icon="mdi-account"
                    label="WhatsApp"
                    filled
                    rounded
                    class="rounded-small"
                    @change="getTemplatesList"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item two-line selectable v-on="on" v-bind="attrs" class="pl-3">
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.name + " " }}
                            </v-list-item-title>

                            <v-list-item-subtitle>
                              {{ item.number }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>

              <!-- Numero -->
              <v-col cols="12">
                <!-- {{ "available: " + available }} -->
                <ValidationProvider name="número" :rules="{ required: true, regex: /^[0-9+]+$/ }" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.number"
                    :error-messages="errors"
                    class="rounded-small"
                    label="Número"
                    prepend-inner-icon="mdi-numeric"
                    required
                    filled
                    rounded
                    dense
                    clearable
                    @change="validateNumber"
                    :disabled="selectedItem == null || module === 'contacts'"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col cols="12">
                <v-switch v-if="available && selectedItem" v-model="withTemplate" label="Con plantilla"></v-switch>
              </v-col>

              <!-- Con plantila -->

              <!-- Plantilla -->
              <v-col cols="12" class="py-0" v-if="available === 1 && withTemplate">
                <template v-if="[4, 6].includes(selectedItem.type)">
                  <ValidationProvider name="plantilla" rules="required" v-slot="{ errors }">
                    <v-select
                      :disabled="isLoadingTemplates"
                      v-model="selectTemplate"
                      :items="templatesList"
                      :error-messages="errors"
                      item-text="title"
                      item-value="id"
                      return-object
                      prepend-inner-icon="mdi-account"
                      label="Plantilla"
                      filled
                      rounded
                      class="rounded-small"
                      @change="onTemplateChange"
                    >
                    </v-select>
                  </ValidationProvider>
                </template>
              </v-col>

              <!-- Archivo / File -->
              <!-- Drop Zone -->
              <v-col cols="12" v-if="hasTemplateFile">
                <div
                  class="drop-zone"
                  :class="{ 'drop-zone--active': isDragging }"
                  @dragover.prevent="isDragging = true"
                  @dragleave.prevent="isDragging = false"
                  @drop.prevent="handleDrop"
                  @click="triggerFileInput"
                >
                  <v-icon size="36" color="grey">
                    mdi-cloud-upload
                  </v-icon>

                  <div class="mt-2">
                    <span v-if="!fileName">Seleccionar archivo PDF</span>
                    <strong v-else>{{ fileName }}</strong>
                  </div>
                </div>
                <input
                  ref="fileInput"
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png,.webp"
                  hidden
                  @change="handleFileSelect"
                />
              </v-col>

              <!-- Mensaje -->
              <v-col cols="12" v-if="available === 1">
                <template v-if="[4, 6].includes(selectedItem.type) && withTemplate">
                  <v-card flat color="grey lighten-3" v-show="selectTemplate != []">
                    <v-card-text>
                      {{ selectTemplate.message }}
                    </v-card-text>
                  </v-card>
                </template>

                <template v-else>
                  <ValidationProvider name="mensaje" rules="required" v-slot="{ errors }">
                    <v-textarea
                      v-model="payload.message"
                      :error-messages="errors"
                      class="rounded-small"
                      label="Mensaje"
                      prepend-inner-icon="mdi-message-text"
                      required
                      filled
                      rounded
                      dense
                      clearable
                      :disabled="selectedItem == null"
                    >
                    </v-textarea>
                  </ValidationProvider>
                </template>
              </v-col>

              <v-col cols="12" v-else-if="available == 2">
                <v-card flat color="grey lighten-3">
                  <v-card-text>
                    Este número de teléfono ya possee un ticket abierto. ¿Desea enviarle un mensaje?
                  </v-card-text>
                  <v-container>
                    <v-card outlined>
                      <v-card-text>
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title>{{ openTicket.agent }}</v-list-item-title>
                            <v-list-item-subtitle>{{ openTicket.date }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card-text>
                    </v-card>
                  </v-container>
                  <v-card-actions>
                    <v-btn text color="error" @click="cancelNumber">No</v-btn>
                    <v-btn text color="success" @click="available = 1">
                      Sí
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col cols="12" v-if="parameter_number > 0" dense>
                <v-card outlined>
                  <v-card-text>
                    <p>Parámetros</p>
                    <v-row dense>
                      <v-col v-for="(paramName, index) in parameter" :key="index" cols="12">
                        <ValidationProvider :name="paramName" rules="required" v-slot="{ errors }">
                          <v-text-field
                            :label="paramName"
                            :placeholder="`Ingrese ${paramName}`"
                            v-model="payload.parameters[index]"
                            filled
                            rounded
                            clearable
                            :error-messages="errors"
                            class="rounded-small"
                          />
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mx-2 justify-end">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog">
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              :disabled="isSendingMessage || (![4, 6].includes(selectedItem.type) && payload.message === '')"
              rounded
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Enviar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  props: {
    isActive: Boolean,
    agent: String,
    number: String,
    module: String,
  },

  data: () => ({
    isLoading: false,
    isSendingMessage: false,
    isLoadingTemplates: false,
    withTemplate: false,
    available: 0,
    selectedItem: null,
    payload: {
      file: false,
      template_id: null,
      message: "",
      number: "",
      config_id: null,
      parameters: [],
    },
    parameter_number: null,
    parameter: [],
    whatsappList: [],
    templatesList: [],
    selectTemplate: [],
    openTicket: {
      agent: "",
      date: "",
    },
    selectedFile: null,
    fileName: null,
    isDragging: false,
  }),

  computed: {
    hasTemplateFile() {
      return !!this.selectTemplate?.file;
    },
  },

  watch: {
    selectTemplate(newTemplate) {
      if (newTemplate && newTemplate.parameter_number > 0) {
        this.parameter_number = newTemplate.parameter_number;
        this.parameter = newTemplate.parameter;
        this.payload.parameters = new Array(newTemplate.parameter_number).fill("");
      } else {
        this.parameter_number = 0;
        this.parameter = [];
        this.payload.parameters = [];
      }
    },
  },

  created() {
    if (this.number) {
      this.payload.number = this.number;
    }
    this.getWhatsappList();
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput?.click();
    },

    /**
     * Maneja la selección de archivos y valida el tipo antes de procesarlo.
     * Permite PDF e imágenes (jpg, png, webp).
     * @param {Event} event - Evento change del input file
     */
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/webp"];

      // Validar tipo de archivo
      if (!allowedTypes.includes(file.type)) {
        // Limpia el input para evitar que quede el archivo inválido
        event.target.value = "";

        if (this.$toast) {
          this.$toast.error("Solo se permiten archivos PDF o imágenes (JPG, PNG, WEBP)");
        } else {
          alert("Solo se permiten archivos PDF o imágenes (JPG, PNG, WEBP)");
        }

        return;
      }

      this.selectedFile = file;
      this.fileName = file.name;
    },

    handleDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.validateFile(file);
    },

    cancelNumber() {
      this.available = 0;
      this.payload.number = "";
    },

    async getWhatsappList() {
      try {
        const { data } = await PbxHttpClient.get("/whatsapps/config/index_select");
        this.whatsappList = data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener la lista de whatsapp", "¡Error!");
      }
    },

    onTemplateChange() {
      if (this.selectTemplate && this.selectTemplate.parameter_number > 0) {
        this.parameter_number = this.selectTemplate.parameter_number;
        this.parameter = this.selectTemplate.parameters;
        this.payload.parameters = this.parameter.map(() => "");
      } else {
        this.parameter_number = null;
        this.parameter = [];
        this.payload.parameters = [];
      }
    },

    async getTemplatesList() {
      this.selectTemplate = [];
      this.isLoadingTemplates = true;

      try {
        const { data } = await PbxHttpClient.get("/templates-Meta");

        this.templatesList = data.data.filter((template) => template.whatsapp_id === this.selectedItem.id);
      } catch (err) {
        this.$snotify.error("No se pudo obtener la lista de whatsapp", "¡Error!");
      } finally {
        this.isLoadingTemplates = false;
        if (this.module === "contacts") {
          this.validateNumber();
        }
      }
    },

    async submitForm() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Enviando",
      });

      this.isSendingMessage = true;
      this.payload.config_id = this.selectedItem.id;

      if ([4, 6].includes(this.selectedItem.type)) {
        this.payload.template_id = this.selectTemplate.id;
        this.payload.message = "*" + this.agent + "*: \n" + this.selectTemplate.message;
      } else {
        this.payload.message = "*" + this.agent + "*: \n" + this.payload.message;
      }

      try {
        // 🔥 Si hay archivo → usar FormData
        if (this.selectedFile) {
          const formData = new FormData();

          // Campos normales
          Object.keys(this.payload).forEach((key) => {
            if (Array.isArray(this.payload[key])) {
              this.payload[key].forEach((value, index) => {
                formData.append(`${key}[${index}]`, value);
              });
            } else if (this.payload[key] !== null) {
              formData.append(key, this.payload[key]);
            }
          });

          // Archivo
          formData.append("file", this.selectedFile);
          formData.append("mediaType", "file");
          formData.append("type", "file");

          await PbxHttpClient.post("/whatsapps/send_messages_number", formData);
        } else {
          // 🚀 Envío normal sin archivo
          await PbxHttpClient.post("/whatsapps/send_messages_number", this.payload);
        }

        this.$snotify.success("Mensaje enviado con éxito.", "¡Hecho!");
        this.closeDialog();

        // Limpiar archivo
        this.selectedFile = null;
        this.fileName = null;
      } catch (err) {
        console.error(err);
        this.$snotify.error("No se pudo enviar el mensaje", "¡Error!");
      } finally {
        this.isSendingMessage = false;
        this.$store.commit("layout/SET_OVERLAY", {
          value: false,
          title: "",
        });
      }
    },

    async validateNumber() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });

      this.isSendingMessage = true;

      try {
        const { data } = await PbxHttpClient.post("/whatsapps/consult_messages_fast", {
          number: this.payload.number,
          config_id: this.selectedItem.id,
        });

        if (data.succes) {
          if (data.message === "Número disponible") {
            this.$snotify.success(data.message, "Disponible");
            this.available = 1;
          } else {
            this.$snotify.warning(data.message);
            this.available = 2;
            this.openTicket.agent = data.ticket.user_name.name;
            this.openTicket.date = data.ticket.updated_at;
          }
        }
      } catch (err) {
        this.$snotify.error("consultar", "¡Error!");
      } finally {
        this.$store.commit("layout/SET_OVERLAY", {
          value: false,
          title: "",
        });
        this.isSendingMessage = false;
      }
    },

    async closeDialog() {
      await this.$refs.obs.reset();

      this.payload = {
        template_id: null,
        message: "",
        number: "",
        config_id: null,
        parameters: [],
      };

      this.selectedFile = null;
      this.fileName = null;

      this.cancelNumber();
      this.$emit("dialog:close");
    },
  },
};
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #bdbdbd;
  border-radius: 12px;
  padding: 32px 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.drop-zone--active {
  border-color: #1976d2;
  background-color: #f5f9ff;
}
</style>
